import request from '../../../shared/request'

export function getJobSiteEstimates(job_id) {
  return request(`/job/job_site_estimates/${job_id}/`)
}

export function getEstimateSections(estimate_id) {
  return request(`/job/job_site_estimates/${estimate_id}/section`)
}

export function getEstimateItems(estimate_id) {
  return request(`/job/job_site_estimates/${estimate_id}/item`)
}

export function createJobSiteEstimate(payload) {
  return request(`/job/job_site_estimates/${payload.jobId}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobSiteEstimate(payload) {
  return request(`/job/job_site_estimates/${payload.estimateId}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobSiteEstimate(payload) {
  return request(`/job/job_site_estimates/${payload.estimate_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadAttachments(payload) {
  return request(`/job/job_site_estimates/${payload.estimateId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(estimateId) {
  return request(`/job/job_site_estimates/${estimateId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/job_site_estimates/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/job/job_site_estimates/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSiteEstimates.js